import $ from 'jquery'

import Collapse from 'garden/src/js/components/collapse'

export default ($el) => $el.collapse()
